var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#FFF7E1",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 22.75H21.75",
    stroke: "#BA9421",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 22.75V19.75C12.75 19.3522 12.908 18.9706 13.1893 18.6893C13.4706 18.408 13.8522 18.25 14.25 18.25H15.75C16.1478 18.25 16.5294 18.408 16.8107 18.6893C17.092 18.9706 17.25 19.3522 17.25 19.75V22.75",
    stroke: "#BA9421",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12.25V13C8.25 13.5967 8.48705 14.169 8.90901 14.591C9.33097 15.0129 9.90326 15.25 10.5 15.25C11.0967 15.25 11.669 15.0129 12.091 14.591C12.5129 14.169 12.75 13.5967 12.75 13V12.25M12.75 13C12.75 13.5967 12.9871 14.169 13.409 14.591C13.831 15.0129 14.4033 15.25 15 15.25C15.5967 15.25 16.169 15.0129 16.591 14.591C17.0129 14.169 17.25 13.5967 17.25 13V12.25M17.25 13C17.25 13.5967 17.4871 14.169 17.909 14.591C18.331 15.0129 18.9033 15.25 19.5 15.25C20.0967 15.25 20.669 15.0129 21.091 14.591C21.5129 14.169 21.75 13.5967 21.75 13V12.25H8.25L9.75 9.25H20.25L21.75 12.25",
    stroke: "#BA9421",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 22.7492V15.1367",
    stroke: "#BA9421",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 22.7492V15.1367",
    stroke: "#BA9421",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressCardIcon);
export default __webpack_public_path__ + "static/media/address_card_icon.f2e503eb7d5e1e061f2a76ed7ca01185.svg";
export { ForwardRef as ReactComponent };